import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { options } from 'marked';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { B2C } from './b2c';
@Injectable({
  providedIn: 'root',
})
export class HttpClientRequestService {
  options = {
    headers: new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Ocp-Apim-Subscription-Key', environment.apimSubscriptionKey),
  };

  private baseUrl: string;
  constructor(public http: HttpClient) {
    this.baseUrl = environment.apiManagmet;
  }

  genericGet<T>(route: string, params: HttpParams): Observable<T> {
    return this.http.get<T>(this.createCompleteRoute(route, this.baseUrl), this.options);
  }

  public get = (route: string, params: HttpParams) => {
    return this.http.get(this.createCompleteRoute(route, this.baseUrl), {
      ...this.options,
      params: params,
    });
  };

  public post = <T = any>(route: string, body: any): Observable<T> => {
    return this.http.post<T>(this.createCompleteRoute(route, this.baseUrl), body, this.options);
  };

  public put = (route: string, body: any) => {
    return this.http.put(this.createCompleteRoute(route, this.baseUrl), body, this.options);
  };

  public delete = (route: string) => {
    return this.http.delete(this.createCompleteRoute(route, this.baseUrl), this.options);
  };

  private createCompleteRoute = (route: string, envAddress: string) => {
    return `${envAddress}/${route}`;
  };
}
